<template>
    <div id="app">
        <Header />
        <div class="minh">
            <router-view :key="$route.fullPath"></router-view>
        </div>
        <Footer />
    </div>
</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'
export default {
    name: 'Home',
    components: {
        Header,
        Footer
    }
}
</script>

<style lang="scss">
.minh {
    min-height: 70vh;
    background: url(./assets/images/bd_bg.jpg) repeat;
}
</style>
